<template>
  <div class="studio-product-events" :class="{ review: review }">
    <FullEventsCalendar
      :calendarEvents="product.events"
      :enableScrollToDay="false"
    />
    <div class="row page-bottom-filler"></div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import FullEventsCalendar from '@/web/components/events/FullEventsCalendar';

export default Vue.extend({
  name: 'StudioProductEvents',
  components: {
    FullEventsCalendar,
  },
  props: {
    review: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      product: 'product/product',
    }),
  },
});
</script>

<style scoped>
.review {
  pointer-events: none;
}
</style>
